import { ConnectorLogo } from "@/components/connectors/ConnectorLogo.tsx";
import { getServiceIcon } from "@/components/connectors/providerIcons.tsx";
import type { ArtifactComponent } from "@/types/artifacts-view.ts";

type ConnectorHeaderComponentData = Extract<ArtifactComponent, { type: "connectorHeader" }>;

/**
 * Headline of a connect card — the service's own mark beside its name.
 *
 * Two sources, because our connectors come from two places: the handful we
 * integrated by hand have drawn SVGs, while the catalog's long tail (every MCP
 * server, every OpenAPI spec) has only a homepage — which the shared library
 * may still have a mark for, and otherwise falls back to a favicon.
 * `ConnectorLogo` degrades again to a generic plug when even that fails to
 * load.
 *
 * Layout matches the read-only headline in `SubjectLineBlock` so a connect
 * card sits flush with every other artifact card.
 */
export const ConnectorHeaderBlock = ({
  component,
}: {
  component: ConnectorHeaderComponentData;
}) => {
  const brandIcon = getServiceIcon({
    name: component.title,
    provider: component.provider,
    iconVariant: component.iconVariant,
    websiteUrl: component.websiteUrl,
  });

  return (
    <div className="flex items-center gap-2 font-semibold text-base">
      {brandIcon ?? (
        <ConnectorLogo websiteUrl={component.websiteUrl} name={component.title} size="sm" />
      )}
      {component.title}
    </div>
  );
};
